import { render } from "./SWGenerationManagement.vue?vue&type=template&id=ef16cc48"
import script from "./SWGenerationManagement.vue?vue&type=script&lang=js"
export * from "./SWGenerationManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__